import React from 'react';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

/**
 * Override the scaffolder page to restrict access to devops group only.
 */
export const scaffolderGuardModule = scaffolderPlugin.withOverrides({
  extensions: [
    scaffolderPlugin.getExtension('page:scaffolder').override({
      params: {
        loader: async () => {
          const { ScaffolderPage } = await import(
            '@backstage/plugin-scaffolder'
          );
          const { DevopsGuard } = await import(
            '../deploy-metrics/components/DevopsGuard'
          );
          return compatWrapper(
            React.createElement(
              DevopsGuard,
              null,
              React.createElement(ScaffolderPage),
            ),
          );
        },
      },
    }),
  ],
});
